import type { AdminOrderInquiryListInput } from '@repo/api-contracts';
import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from '@/shared/api';

/**
 * 관리자 문의 목록(orderInquiryManagement.list) — 쪽·상태(기본 처리 중)·종류 필터. 조건을 바꾸는 동안 이전 쪽 표를
 * 자리표시자로 유지한다(주문 목록과 같다).
 */
export const useOrderInquiriesListQuery = (input: AdminOrderInquiryListInput) =>
  trpc.orderInquiryManagement.list.useQuery(input, { placeholderData: keepPreviousData });
